import React from 'react';
import './TechnologyIcon.sass';

const shapes = {
  bulb: {
    shape:
      'M4.280964,9.82210428 C4.44277141,9.8907857 4.61039952,9.95028147 4.78304712,10 L6.83725081,10 C10.2620192,8.35252864 9.40336207,4.4281779 8.48061377,3.42654818 C8.84051026,4.86449076 8.06977303,5.14756003 8.06977303,5.89159261 C8.06977303,4.97970956 7.69572183,4.22225362 7.34926122,3.48456061 L6.21112395,6.56125694 L7.43496376,6.56125694 L4.280964,9.82210428 Z M3.97975148,9.68019388 C1.6852242,8.48715804 0.794326045,5.340592 3.95273798,2.19402596 C3.39481626,3.21414351 4.15815835,4.70631708 4.37220638,5.06991113 C4.37220638,1.78318522 7.23448682,0 7.23448682,0 C6.42175167,1.36328233 6.83045952,2.37526923 7.31848311,3.41889803 L3.76318719,7.16438881 L4.90676207,7.15508485 L3.97975148,9.68019388 Z',
    alt: 'bulb'
  },
  battery: {
    shape:
      'M7.6630225,2.13158306 C7.57119055,2.04038155 7.42926147,1.9947808 7.23746541,1.9947808 L6.35643103,1.9947808 L6.35643103,1.57824618 C6.35643103,1.37929002 6.31254809,1.23214205 6.22455206,1.13680226 C6.13272011,1.04560075 5.99079102,1 5.79899496,1 L4.99590651,1 C4.80411045,1 4.66225808,1.04560075 4.57034941,1.13680226 C4.4824301,1.23214205 4.43847044,1.37929002 4.43847044,1.57824618 L4.43847044,1.9947808 L3.55743607,1.9947808 C3.36564001,1.9947808 3.22378764,2.04038155 3.13187897,2.13158306 C3.04395966,2.22692285 3,2.37407082 3,2.57302698 L3,8.3800798 C3,8.57903596 3.04395966,8.72626352 3.13187897,8.82152373 C3.22378764,8.91272523 3.36564001,8.95832599 3.55743607,8.95832599 L7.23754212,8.95832599 C7.42933818,8.95832599 7.57126727,8.91280482 7.66309922,8.82152373 C7.75101853,8.72626352 7.79497819,8.57903596 7.79497819,8.3800798 L7.79497819,2.57302698 C7.79490147,2.37407082 7.75101853,2.22692285 7.6630225,2.13158306',
    alt: 'battery'
  },
  hydrogen: {
    shape:
      'M5.6 0S3.433 2.067 2.697 2.83C1.962 3.597 1.5 4.63 1.5 5.8 1.5 8.112 3.335 10 5.61 10c2.264 0 4.11-1.876 4.11-4.202 0-1.19-.484-2.26-1.264-3.023C7.71 2.045 5.6 0 5.6 0zM3.8 3.706V7.99h.943V6.142h1.734V7.99h.942V3.706h-.943V5.35H4.743V3.706H3.8z',
    alt: 'hydrogen'
  },
  sun: {
    shape:
      'M3.26689772,7.79549835 C2.98529611,7.50412272 2.98529611,7.50412272 2.70559849,7.79549835 L2.14429927,8.38023311 C1.86460165,8.67359224 1.86460165,8.67359224 2.14429927,8.96496787 C2.42399688,9.2563435 2.42399688,9.2563435 2.70559849,8.96496787 L3.26689772,8.38023311 C3.54650013,8.08895666 3.54650013,8.08895666 3.26689772,7.79549835 Z M8.87570119,1.95251446 C8.59600358,1.66113883 8.59600358,1.66113883 8.31440196,1.95251446 L7.75310274,2.53724922 C7.47340512,2.82862485 7.47340512,2.82862485 7.75310274,3.12198398 C8.03470435,3.41335961 8.03470435,3.41335961 8.31440196,3.12198398 L8.87570119,2.53724922 C9.1553988,2.24379092 9.1553988,2.24379092 8.87570119,1.95251446 Z M7.75310274,7.79549835 C7.47340512,8.08885748 7.47340512,8.08885748 7.75310274,8.38023311 L8.31440196,8.96496787 C8.59600358,9.2563435 8.59600358,9.2563435 8.87570119,8.96496787 C9.1553988,8.67359224 9.1553988,8.67359224 8.87570119,8.38023311 L8.31440196,7.79549835 C8.03479955,7.5042219 8.03479955,7.5042219 7.75310274,7.79549835 Z M2.14429927,1.95251446 C1.86460165,2.24389009 1.86460165,2.24389009 2.14429927,2.53724922 L2.70559849,3.12198398 C2.98529611,3.41335961 2.98529611,3.41335961 3.26689772,3.12198398 C3.54659533,2.82862485 3.54659533,2.82862485 3.26689772,2.53724922 L2.70559849,1.95251446 C2.42390168,1.66113883 2.42390168,1.66113883 2.14429927,1.95251446 Z M5.51000023,8.76453555 C5.11330181,8.76453555 5.11330181,8.76453555 5.11330181,9.17779704 L5.11330181,10.0042208 C5.11330181,10.4174823 5.11330181,10.4174823 5.51000023,10.4174823 C5.90669865,10.4174823 5.90669865,10.4174823 5.90669865,10.0042208 L5.90669865,9.17779704 C5.90669865,8.76453555 5.90669865,8.76453555 5.51000023,8.76453555 Z M5.51000023,0.5 C5.11330181,0.5 5.11330181,0.5 5.11330181,0.913261489 L5.11330181,1.73968529 C5.11330181,2.15294678 5.11330181,2.15294678 5.51000023,2.15294678 C5.90669865,2.15294678 5.90669865,2.15294678 5.90669865,1.73968529 L5.90669865,0.913261489 C5.90669865,0.5 5.90669865,0.5 5.51000023,0.5 Z M8.68330198,5.45874117 C8.68330198,5.87200265 8.68330198,5.87200265 9.0800004,5.87200265 L9.87330204,5.87200265 C10.2700005,5.87200265 10.2700005,5.87200265 10.2700005,5.45874117 C10.2700005,5.04547968 10.2700005,5.04547968 9.87330204,5.04547968 L9.0800004,5.04547968 C8.68330198,5.04547968 8.68330198,5.04547968 8.68330198,5.45874117 Z M0.75,5.45874117 C0.75,5.87200265 0.75,5.87200265 1.14669842,5.87200265 L1.94000006,5.87200265 C2.33669848,5.87200265 2.33669848,5.87200265 2.33669848,5.45874117 C2.33669848,5.04547968 2.33669848,5.04547968 1.94000006,5.04547968 L1.14669842,5.04547968 C0.75,5.04547968 0.75,5.04547968 0.75,5.45874117 Z M5.51000023,7.93811175 C6.82442669,7.93811175 7.89000034,6.82804795 7.89000034,5.45874117 C7.89000034,4.08943438 6.82442669,2.97937058 5.51000023,2.97937058 C4.19557377,2.97937058 3.13000011,4.08943438 3.13000011,5.45874117 C3.13000011,6.82804795 4.19557377,7.93811175 5.51000023,7.93811175 Z',
    alt: 'sun'
  },
  solar_thermal: {
    shape:
      'M72.707 361.77c-17.192 50.203 17.192 70.147 0 120.35H89.9c17.19-50.203-17.193-70.147 0-120.35H72.706zM110.702 361.77c-17.193 50.203 17.192 70.147 0 120.35h17.192c17.193-50.203-17.192-70.147 0-120.35h-17.192zM148.526 361.77c-17.193 50.203 17.192 70.147 0 120.35h17.192c17.193-50.203-17.192-70.147 0-120.35h-17.192z',
    alt: 'solar thermal'
  }
};

const styles = {
  default: {
    strokeWidth: 0
  },
  circleFull: {
    strokeWidth: '.5px'
  },
  circleEmpty: {
    fill: 'none',
    strokeWidth: '.5px'
  }
};

export default function TechnologyIcon({ name, title, value }) {
  if (name === 'solar_thermal') {
    return (
      <svg
        className={name}
        style={styles.default}
        alt={shapes[name] && shapes[name].alt}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-18.479 833.854 37 15"
      >
        <circle fill="#FA2A00" cx="-11.182" cy="841.354" r="7.385" />
        <circle
          style={value >= 1 ? styles.circleFull : styles.circleEmpty}
          stroke="#FA2A00"
          strokeWidth=".5"
          cx=".95"
          cy="841.354"
          r="2.638"
        />
        <circle
          style={value >= 2 ? styles.circleFull : styles.circleEmpty}
          stroke="#FA2A00"
          strokeWidth=".5"
          cx="8.336"
          cy="841.354"
          r="2.638"
        />
        <circle
          style={value >= 3 ? styles.circleFull : styles.circleEmpty}
          stroke="#FA2A00"
          strokeWidth=".5"
          cx="15.721"
          cy="841.354"
          r="2.638"
        />
        <g fill="#FFF">
          <path
            fill="#FFF"
            d="M-15.016 838.34h1.167v6.73h-1.166zM-12.85 838.34h1.168v6.73h-1.167zM-10.683 838.34h1.167v6.73h-1.167zM-8.516 838.34h1.167v6.73h-1.166z"
          />
        </g>
      </svg>
    );
  }
  return (
    <span className="technology-icon" title={title}>
      <svg
        className={name}
        viewBox="-2 -2 37 15"
        style={styles.default}
        alt={shapes[name] && shapes[name].alt}
      >
        <circle cx="5.5" cy="5.5" r="7" />
        <path
          fill="white"
          d={shapes[name] && shapes[name].shape}
          fillRule="evenodd"
        />
        <circle
          cx="17"
          cy="5.5"
          r="2.5"
          style={value >= 1 ? styles.circleFull : styles.circleEmpty}
        />
        <circle
          cx="24"
          cy="5.5"
          r="2.5"
          style={value >= 2 ? styles.circleFull : styles.circleEmpty}
        />
        <circle
          cx="31"
          cy="5.5"
          r="2.5"
          style={value >= 3 ? styles.circleFull : styles.circleEmpty}
        />
      </svg>
    </span>
  );
}
